import React, { useState, useEffect } from "react";
import { useStateValue } from "../../../State";
import "../combinedplan.css";

import ContentBoxMUI from "../../../Components/ContentBoxMUI";
import ChildRow from "../../Vasu/ChildRow";
import DiscussionDetail from "./DiscussionDetail";
import { getProfilePictureData } from "../../../utils";
import { getCombinedPlanSectionTitle } from "../sectionTitles";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const DiscussionPart = (props) => {
  const { state } = useStateValue();
  const combinedPlanData = state.combinedPlan.data;
  const objectivesSection = combinedPlanData?.DiscussionObjectives ?? {};
  const otherItemsSection = combinedPlanData?.DiscussionOtherItems ?? {};
  const objectivesTitle = objectivesSection.Title || "Tavoitteet";
  const otherItemsTitle = otherItemsSection.Title || "Muut keskustelun asiat";
  const Objectives = objectivesSection.EvaluationSections ?? [];
  const OtherItems = otherItemsSection.EvaluationSections ?? [];
  const PrevGoals = combinedPlanData?.DiscussionPrevVasuNotes ?? null;

  const { history, match } = props;
  const childId = match.params.ChildId;
  const child = state.children?.ChildList?.find((c) => c.Id === childId);
  const childpicture = getProfilePictureData(state, child?.Id);
  const childFirstName = child?.FirstName ?? null;
  const childLastName = child?.LastName ?? null;
  const childColor = child?.BgColor ?? null;
  const sectionTitle = getCombinedPlanSectionTitle(
    combinedPlanData,
    "discussion",
    combinedPlanData?.DiscussionSectionTitle,
  );

  const [selectedIndex, setSelectedIndex] = useState(-1);

  useEffect(() => {
    if (!combinedPlanData) {
      history.replace(`/combinedplan/${childId}`);
    }
  }, []);

  const handleBackClick = () => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
      setSelectedIndex(-1);
      window.onpopstate = undefined;
      window.history.back();
    };
  };

  const handleItemClick = (index) => {
    setSelectedIndex(index);
    handleBackClick();
  };

  if (!combinedPlanData) {
    return <div className="CombinedPlanContainer"></div>;
  }

  // Merge objectives and other items into a single navigable list so the
  // detail view can swipe/arrow between all sub-items like the support tiers
  const hasPrevGoals =
    !!PrevGoals &&
    ((PrevGoals.Title || "") !== "" ||
      (PrevGoals.SubTitle || "") !== "" ||
      (PrevGoals.Text || "") !== "");

  const prevGoalsItem = hasPrevGoals
    ? {
        SectionTitle: PrevGoals.Title || "",
        Label: PrevGoals.SubTitle || "",
        MainText: PrevGoals.Text || "",
        MainTextLabel: PrevGoals.SubTitle || PrevGoals.Title || "",
        MainTextSaved: PrevGoals.Saved || "",
        Evaluations: [],
        Group: "previousGoals",
      }
    : null;

  const allItems = [
    ...(prevGoalsItem ? [prevGoalsItem] : []),
    ...Objectives.map((o) => ({
      ...o,
      Group: "objective",
      SectionTitle: objectivesTitle,
    })),
    ...OtherItems.map((o) => ({
      ...o,
      Group: "other",
      SectionTitle: otherItemsTitle,
    })),
  ];

  return (
    <div className="CombinedPlanContainer">
      <ContentBoxMUI>
        <Box sx={{ mt: 1 }}>
          <ChildRow
            childpicture={childpicture}
            childFirstName={childFirstName}
            childLastName={childLastName}
            childColor={childColor}
            FormId={combinedPlanData.PlanId}
            history={history}
          />
        </Box>

        {selectedIndex === -1 ? (
          <div>
            <h4 className="textCenter">{sectionTitle}</h4>

            {/* Previous goals */}
            {prevGoalsItem && (
              <Box sx={{ mt: 2 }}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ ml: 2, mb: 1 }}
                >
                  {prevGoalsItem.SectionTitle}
                </Typography>
                <List sx={{ mt: -1 }}>
                  <ListItemButton
                    className="boxed"
                    sx={{
                      backgroundColor: "#afdfc8",
                      borderRadius: 0.5,
                      mt: 1.5,
                      boxShadow: 2,
                    }}
                    onClick={() => handleItemClick(0)}
                  >
                    <ListItemText
                      primaryTypographyProps={{
                        fontWeight: "Bold",
                        fontSize: 16,
                        ml: 2,
                      }}
                      primary={
                        prevGoalsItem.Label || prevGoalsItem.SectionTitle
                      }
                    />
                    <ListItemIcon>
                      <ArrowForwardIosIcon fontWeight="Bold" fontSize="small" />
                    </ListItemIcon>
                  </ListItemButton>
                </List>
              </Box>
            )}

            {/* Objectives */}
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                sx={{ ml: 2, mb: 1 }}
              >
                {objectivesTitle}
              </Typography>
              {Objectives.length > 0 ? (
                <List sx={{ mt: -1 }}>
                  {Objectives.map((obj, index) => (
                    <ListItemButton
                      key={`obj-${index}`}
                      className="boxed"
                      sx={{
                        backgroundColor: "#afdfc8",
                        borderRadius: 0.5,
                        mt: 1.5,
                        boxShadow: 2,
                      }}
                      onClick={() =>
                        handleItemClick((prevGoalsItem ? 1 : 0) + index)
                      }
                    >
                      <ListItemText
                        primaryTypographyProps={{
                          fontWeight: "Bold",
                          fontSize: 16,
                          ml: 2,
                        }}
                        primary={obj.Label}
                      />
                      <ListItemIcon>
                        <ArrowForwardIosIcon
                          fontWeight="Bold"
                          fontSize="small"
                        />
                      </ListItemIcon>
                    </ListItemButton>
                  ))}
                </List>
              ) : (
                <Box
                  sx={{
                    backgroundColor: "#afdfc8",
                    borderRadius: 2,
                    boxShadow: 1,
                    mt: 1,
                    p: 2,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "#9e9e9e", fontStyle: "italic" }}
                  >
                    Ei vielä kirjauksia
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Other Items */}
            <Box sx={{ mt: 2 }}>
              <Divider sx={{ mb: 2 }} />
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                sx={{ ml: 2, mb: 1 }}
              >
                {otherItemsTitle}
              </Typography>
              {OtherItems.length > 0 ? (
                <List sx={{ mt: -1 }}>
                  {OtherItems.map((item, index) => (
                    <ListItemButton
                      key={`other-${index}`}
                      className="boxed"
                      sx={{
                        backgroundColor: "#afdfc8",
                        borderRadius: 0.5,
                        mt: 1.5,
                        boxShadow: 2,
                      }}
                      onClick={() =>
                        handleItemClick(
                          (prevGoalsItem ? 1 : 0) + Objectives.length + index,
                        )
                      }
                    >
                      <ListItemText
                        primaryTypographyProps={{
                          fontWeight: "Bold",
                          fontSize: 16,
                          ml: 2,
                        }}
                        primary={item.Label}
                      />
                      <ListItemIcon>
                        <ArrowForwardIosIcon
                          fontWeight="Bold"
                          fontSize="small"
                        />
                      </ListItemIcon>
                    </ListItemButton>
                  ))}
                </List>
              ) : (
                <Box
                  sx={{
                    backgroundColor: "#afdfc8",
                    borderRadius: 2,
                    boxShadow: 1,
                    mt: 1,
                    p: 2,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "#9e9e9e", fontStyle: "italic" }}
                  >
                    Ei vielä kirjauksia
                  </Typography>
                </Box>
              )}
            </Box>
          </div>
        ) : (
          <DiscussionDetail
            items={allItems}
            SelectedSlideIndex={selectedIndex}
            sectionTitle={sectionTitle}
          />
        )}
      </ContentBoxMUI>
    </div>
  );
};

export default DiscussionPart;
